import { Location } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import {
  PwdValidatorParam,
  PwdValidatorRes,
  User,
} from "src/app/_models/user-models/user";
import { UserService } from "src/app/_services/user/user.service";

import { Message } from "primeng/api";
// import { Message } from "primeng/components/common/api";

import { Store } from "@ngrx/store";
import { Gblenv } from "src/app/_models/orginfo/gblenv.model";
import { AuthService } from "src/app/_services/auth/auth.service";
import { AlertifyService } from "src/app/_services/common/alertify.service";
import { AppSessionState } from "src/app/_services/common/app.service";
import { UserSessionStateModel } from "src/app/_store/models/user-session-state.model";
import * as LoginActions from "../../../_store/actions/login.actions";

@Component({
  selector: "app-update-user-profile",
  templateUrl: "./update-user-profile.component.html",
})
export class UpdateUserProfileComponent implements OnInit {
  passwordForm: FormGroup;
  oldPassword: string;
  newPassword: string;
  confirmPassword: string;
  client = {} as User;
  msgs: Message[] = [];

  //Pwd Validation
  pwdPolicyOrg: Gblenv;
  isPolicyRestored: boolean = false;
  isPasswordValid: boolean;
  validationMessage: string[];
  validationMessageForTT: string;
  pwdValidatorRes: PwdValidatorRes;
  pwdValidatorParam: PwdValidatorParam = new PwdValidatorParam();

  isPasswordMasked: boolean = true;

  constructor(
    private location: Location,
    private router: Router,
    private userService: UserService,
    private formbuilder: FormBuilder,
    private appSessionState: AppSessionState,
    private alertifyService: AlertifyService,
    private _authService: AuthService,
    private store: Store<any>
  ) {}

  ngOnInit() {
    this.passwordForm = this.formbuilder.group(
      {
        oldPassword: ["", Validators.required],
        newPassword: ["", Validators.required],
        confirmPassword: [Validators.required],
      },
      { validator: this.passwordMatch }
    );

    this.getUserLoginModel();
  }

  goBack(): void {
    if (window.history.length > 1) {
      this.location.back();
    } else {
      this.router.navigate(["/study/profile"]);
    }
  }

  setUserSessionState(data) {
    let loginModel: UserSessionStateModel = {
      LoginTime: new Date(),
      UserInfo: data,
    };
    this.store.dispatch(LoginActions.login({ userSessionDetail: loginModel }));
  }

  onUpdatePassSubmit(client: User) {
    // if(this.oldPassword!== this.client.Pwd){
    //   this.alertifyService.error("Old Password didn't match");
    //   return;
    // }
    if (this.isPasswordValid == false) {
      this.alertifyService.error("Password Invalid");
      return;
    }
    let user = this.client;
    user.Pwd = this.newPassword;
    user.OldPwd = this.oldPassword;

    this.userService.updateUserPassword(user).subscribe(
      (data) => {
        if (data != null) {
          this.alertifyService.success("Password Changed");
          this.appSessionState.setUserToSessionStorage(data);
          this.setUserSessionState(data);
          this.router.navigate(["/study/profile"]);
        } else {
          this.alertifyService.error("Password Change Failure");
        }
      },
      (error) => {
        this.alertifyService.success("Password Change Failed");
      }
    );
  }

  getUserLoginModel() {
    let userData = this.appSessionState.getSessionStorage();
    if (userData != undefined) {
      this.client = JSON.parse(userData);
    } else {
      this.alertifyService.warning("Please login properly");
    }
  }

  passwordMatch(g: FormGroup) {
    return g.get("newPassword").value === g.get("confirmPassword").value
      ? null
      : { mismatch: true };
  }
  // validatePassword(event) {
  //   this.pwdValidatorParam.Password = (event.target as HTMLInputElement).value;
  //   this.pwdValidatorParam.OrgId = this.client.OrgId;
  //   if (
  //     this.pwdValidatorParam.Password !== null &&
  //     this.pwdValidatorParam.Password.trim() !== ""
  //   ) {
  //     this._authService
  //       .ValidatePassword(this.pwdValidatorParam)
  //       .subscribe((res) => {
  //         if (res.IsSucceed) {
  //           this.pwdValidatorRes = res.Result;
  //           this.isPasswordValid = this.pwdValidatorRes.IsPasswordValid;
  //           this.validationMessage = this.pwdValidatorRes.ValidationMessage;
  //           this.validationMessageForTT = this.validationMessage.join("\n");
  //         }
  //       });
  //   }
  // }
  validatePassword(event) {
    const password = (event.target as HTMLInputElement).value.trim();
    this.pwdValidatorParam.Password = password;

    this.pwdValidatorParam.OrgId = this.client.OrgId;

    const validatePasswordResult = (policy) => ({
      minLength: password.length >= policy.PwdLength,
      requireUppercase: /[A-Z]/.test(password),
      requireLowercase: /[a-z]/.test(password),
      requireNumber: /\d/.test(password),
      requireSpecialChar: /[!@#$%^&*(),.?":{}|<>]/.test(password),
    });

    if (!this.isPolicyRestored) {
      this._authService
        .GetPassPolicy(this.pwdValidatorParam.OrgId)
        .subscribe((res) => {
          if (res.IsSucceed) {
            this.pwdPolicyOrg = res.Result;
            this.isPolicyRestored = true;
            if (this.pwdPolicyOrg.PwdEnforce) {
              this.validationMessageForTT = this.generateTooltipContent(
                validatePasswordResult(this.pwdPolicyOrg),
                this.pwdPolicyOrg
              );
            }
          } else {
            this.isPolicyRestored = true;
          }
        });
    } else {
      if (this.pwdPolicyOrg.PwdEnforce) {
        this.validationMessageForTT = this.generateTooltipContent(
          validatePasswordResult(this.pwdPolicyOrg),
          this.pwdPolicyOrg
        );
      }
    }
  }

  generateTooltipContent(
    validationResults: any = {},
    policyOrg: Gblenv
  ): string {
    const messages = [
      {
        text: `• At least ${policyOrg.PwdLength} characters`,
        valid: validationResults.minLength || false,
        include: policyOrg.PwdLength > 0, // Include based on policyOrg property
      },
      {
        text: "• One uppercase letter",
        valid: validationResults.requireUppercase || false,
        include: policyOrg.PwdUpperCase || false,
      },
      {
        text: "• One lowercase letter",
        valid: validationResults.requireLowercase || false,
        include: policyOrg.PwdLowerCase || false,
      },
      {
        text: "• One numeric digit",
        valid: validationResults.requireNumber || false,
        include: policyOrg.PwdNumber || false,
      },
      {
        text: "• One special character",
        valid: validationResults.requireSpecialChar || false,
        include: policyOrg.PwdSpecChr || false,
      },
    ];

    this.isPasswordValid = !messages.some((message) => {
      return message.include && message.include !== message.valid;
    });

    return messages
      .filter((msg) => msg.include)
      .map(
        (msg) =>
          `<span class="${msg.valid ? "greenColor" : "redColor"}">${
            msg.text
          }</span>`
      )
      .join("<br/>");
  }
  togglePasswordMask(): void {
    this.isPasswordMasked = !this.isPasswordMasked;
  }
}
